// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_TIMESHEET, TIMESHEET, EDIT_TIMESHEET, GET_TIMESHEET, DELETE_TIMESHEET } from '../../../../common/constant'

export const actionTimesheet = createAsyncThunk('appTimesheet/actionTimesheet', async (params, thunkAPI) => {
    return await post(TIMESHEET, params, thunkAPI)
})

export const actionAddTimesheet = createAsyncThunk('appTimesheet/actionAddTimesheet', async (params, thunkAPI) => {
    return await put(ADD_TIMESHEET, params, thunkAPI)
})

export const actionGetTimesheet = createAsyncThunk('appTimesheet/actionGetTimesheet', async (params, thunkAPI) => {
    return await post(GET_TIMESHEET, params, thunkAPI)
})

export const actionEditTimesheet = createAsyncThunk('appTimesheet/actionEditTimesheet', async (params, thunkAPI) => {
    return await post(EDIT_TIMESHEET, params, thunkAPI)
})

export const actionDeleteTimesheet = createAsyncThunk('appTimesheet/actionDeleteTimesheet', async (params, thunkAPI) => {
    return await post(DELETE_TIMESHEET, params, thunkAPI)
})

export const appTimesheetSlice = createSlice({
    name: 'appTimesheet',
    initialState: {
        //list
        loading: false,
        timeSheet: null,

        //add
        loadingAdd: false,
        addTimesheet: null,

        //get
        loadingGet: false,
        getTimesheet: null,

        //edit
        loadingEdit: false,
        editTimesheet: null,

        //delete
        loadingDelete: false,
        deleteTimesheet: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetTimesheetResponse: (state) => {
            state.timeSheet = null
        },
        resetAddTimesheetResponse: (state) => {
            state.addTimesheet = null
        },
        resetGetTimesheetResponse: (state) => {
            state.getTimesheet = null
        },
        resetEditTimesheetResponse: (state) => {
            state.editTimesheet = null
        },
        resetDeleteTimesheetResponse: (state) => {
            state.deleteTimesheet = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionTimesheet.pending, (state) => {
                state.loading = true
            })
            .addCase(actionTimesheet.fulfilled, (state, action) => {
                state.loading = false
                state.timeSheet = action.payload
            })
            .addCase(actionTimesheet.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddTimesheet.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddTimesheet.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addTimesheet = action.payload
            })
            .addCase(actionAddTimesheet.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetTimesheet.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetTimesheet.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getTimesheet = action.payload
            })
            .addCase(actionGetTimesheet.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditTimesheet.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditTimesheet.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editTimesheet = action.payload
            })
            .addCase(actionEditTimesheet.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteTimesheet.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteTimesheet.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteTimesheet = action.payload
            })
            .addCase(actionDeleteTimesheet.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetTimesheetResponse, resetAddTimesheetResponse, resetGetTimesheetResponse, resetEditTimesheetResponse, resetDeleteTimesheetResponse } = appTimesheetSlice.actions

export default appTimesheetSlice.reducer